var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cell grid-x" }, [
    _c("div", { staticClass: "cell small-3 head left-light" }, [
      _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "cell small-9 data clearfix" },
      [
        _c(
          "job-preview-right-column",
          _vm._g(
            {
              attrs: {
                "text-count-mode": _vm.textCountMode,
                "highlight-mode": _vm.highlightMode,
                "comment-class": "matching",
                "comment-highlights": _vm.commentHighlights,
              },
            },
            _vm.$listeners
          )
        ),
        _vm._v(" "),
        _vm._t("body", function () {
          return [
            _c("span", {
              staticClass: "pega-break pega-pre-wrap",
              attrs: { id: _vm.targetId, "data-test": "value" },
              domProps: { textContent: _vm._s(_vm.value || "未登録") },
            }),
          ]
        }),
        _vm._v(" "),
        _vm._t("default"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }